import { Box } from '@change-corgi/design-system-legacy/layout';

import { SECTION_ID_MAPPING, useScrollToSection } from '../../hooks/useScrollToSection';
import { DecisionMakerCardsContainer } from '../decisionMakers/DecisionMakerCardsContainer';
import { LegislativeBodiesContainer } from '../decisionMakersLegislativeBodies/LegislativeBodiesContainer';
import { ScrollTrackingWaypointContainer } from '../ScrollTrackingWaypoint';

import { useDecisionMakerSection } from './hooks/useDecisionMakerSection';

type ScrollTrackingProps = Readonly<{
	showLegislativeBodies: boolean;
}>;
const ScrollTracking: React.FC<ScrollTrackingProps> = ({ showLegislativeBodies }) => {
	return (
		<ScrollTrackingWaypointContainer
			name="petition_details_decision_maker_section_view"
			trackingData={{
				view_context: showLegislativeBodies ? 'legislative_bodies_version' : 'non_legislative_bodies_version',
			}}
		/>
	);
};

export const DecisionMakerSection: React.FC = () => {
	const {
		data: { showLegislativeBodies },
	} = useDecisionMakerSection();

	const {
		data: { refs },
	} = useScrollToSection();

	return (
		<div id={SECTION_ID_MAPPING.DECISION_MAKERS} ref={refs[SECTION_ID_MAPPING.DECISION_MAKERS]}>
			<ScrollTracking showLegislativeBodies={showLegislativeBodies} />
			{showLegislativeBodies ? (
				<Box mx={[-16, 0]}>
					<LegislativeBodiesContainer />
				</Box>
			) : (
				<DecisionMakerCardsContainer />
			)}
		</div>
	);
};
